<template>
    <div class="wrap">
<!--        <h3 class="title">我们推荐您绑定如下银行：</h3>-->
<!--        <p>民生银行</p>-->
<!--        <p>光大银行</p>-->
<!--        <p>中信银行</p>-->
<!--        <p>中国银行</p>-->
<!--        <p>邮政储蓄银行</p>-->
<!--        <p>工商银行</p>-->
<!--        <p>浦发银行</p>-->
<!--        <p>建设银行</p>-->
<!--        <p>上海银行</p>-->
<!--        <p>华夏银行</p>-->
<!--        <p>广发银行</p>-->
<!--        <p>北京银行</p>-->
<!--        <p>平安银行</p>-->
<!--        <p>交通银行</p>-->
<!--        <p>招商银行</p>-->
<!--        <p>农业银行</p>-->
<!--        <p>兴业银行</p>-->
        <img width="100%" src="../../assets/img/recommend_bank_img.png">
        <img src="../../assets/img/backPic.png" @click="back" class="pic" v-if="entryMode">
    </div>
</template>

<script>
    export default {
        data() {
            return {
                entryMode: "" //判断是怎么进来的
            }
        },
        created () {
            document.title = "银行列表";
            let entryMode = this.$route.query.entryMode;//判断来源
            if(!!entryMode){
                this.entryMode = entryMode;
            }
        },
        methods: {
            back(){
            }
        },
    }
</script>

<style scoped>
    .wrap{
        padding: 0 10px;
        padding-bottom: 20px;
    }
    .title{
        text-align: left;
        padding: 10px 0;
    }
    .weight {
        font-weight: bold;
    }
    p{
        line-height: 30px;
    }
    .subTitle{
        line-height: 28px;
        margin-top: 10px;
    }
    .pic{
        position: fixed;
        left: 0;
        bottom: 40%;
        opacity: .7;
    }
</style>
